import { createFileRoute, redirect } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { LangProvider } from "../contexts/LangContext";
import { ProfilePage } from "../pages/ProfilePage";
import { buildCompleteHead } from "../utils/seo";
import { storage } from "../lib/storage";

const currentPath = "/profile";
const canonicalUrl = `https://lotin.uz${currentPath}`;
const seoData = buildCompleteHead(
  "default",
  "home",
  canonicalUrl,
  currentPath,
  currentPath,
);

export const Route = createFileRoute("/profile")({
  head: () => ({
    meta: [{ title: "Profil — Lotin.uz" }, ...seoData.meta],
    links: seoData.links,
    htmlProps: { lang: "uz-Latn" },
  }),
  beforeLoad: () => {
    // Check if user is authenticated
    if (typeof window !== "undefined") {
      const token = storage.getItem("auth_token");
      if (!token) {
        throw redirect({ to: "/" });
      }
    }
  },
  component: Profile,
});

function Profile() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = "uz-Latn";
    // Guard for SSR: only call changeLanguage if it exists
    if (i18n?.changeLanguage) {
      i18n.changeLanguage("default");
    }
    document.title = "Profil — Lotin.uz";
  }, [i18n]);

  return (
    <LangProvider lang={"uz-Latn"}>
      <ProfilePage />
    </LangProvider>
  );
}
